<template>
    <el-form class="login-form" ref='loginForm' :model='loginForm'>
        <div class="login-form-title">
            登录
            <span>
                还没有账号？
                <router-link to="/registe">立即注册</router-link>
            </span>
        </div>
        <el-form-item>
            <el-input v-model="loginForm.phone" placeholder="请输入正确的手机号">
                <img slot="prefix" style="padding: 13px 8px;" src="./images/phone.png">
            </el-input>
        </el-form-item>
        <el-form-item>
            <el-input v-model="loginForm.password" placeholder="验证码">
                <template slot="append">
                    <el-button :disabled="verificationCodeStatus">{{verificationCodeStr}}</el-button>
                </template>
            </el-input>
        </el-form-item>
        <el-form-item>
            <el-button class="submitBtn" :type="submitBtnType" :disabled="loginBtnStatus">登录</el-button>
            <router-link to="/login" class="link">密码登录</router-link>
        </el-form-item>
    </el-form>
</template>
<script>
export default {
    data () {
        return {
            loginBtnStatus: false,
            verificationCodeStatus: false,
            verificationCodeStr: '获取验证码',
            loginForm: {
                phone: '',
            }
        }
    },
    methods: {
        getVerificationCode() {
            console.log("sss")
        },
    },
    computed: {
        submitBtnType() {
            return this.loginBtnStatus ? "primary" : "info"
        }
    }
}
</script>
<style lang="scss" scoped>
    .login-form { 
        &-title {
            margin-top: 80px;
            font-size: 16px;
            color: #333333;
            font-weight: bold;
            padding-bottom: 30px;
            span {
                font-weight: normal;
                line-height: 25px;
                font-size: 12px;
                color: #000000;
                float: right;
                a {
                    color: #409EFF;
                }
            }
        }
        .link {
            width: 60px;
            display: block; 
            margin: 0 auto;
            font-size: 12px;
            color: #666666;
        }
        .submitBtn {
            width: 100%;
            margin-top: 18px;
            color: #ffffff;
            font-size: 16px;
        }
    }
</style>





// WEBPACK FOOTER //
// src/pages/Login/phone.vue